import { Button, TextField } from '@lego/connect-components-react';
import { useState } from 'react';

type EditableInputProps = {
  value: string | number;
  onChange: (value: string | number) => void;
};

const EditableInput = ({ value, onChange }: EditableInputProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(String(value));

  const startEditing = () => {
    setDraftValue(String(value));
    setIsEditing(true);
  };

  const commitEdit = () => {
    onChange(draftValue);
    setIsEditing(false);
  };

  return (
    <>
      {isEditing ? (
        <div>
          <TextField
            value={draftValue}
            onChange={(e) => setDraftValue(e.target.value)}
            onBlur={commitEdit}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                commitEdit();
              } else if (e.key === 'Escape') {
                setIsEditing(false);
              }
            }}
            autoFocus
          />
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span className="body-md-medium">{value}</span>
          <Button
            aria-label="Edit simulation name"
            isIconOnly
            iconName="pen"
            onClick={startEditing}
            appearance="ghost"
            size="small"
          />
        </div>
      )}
    </>
  );
};
export default EditableInput;
